import { ExerciseCompareBase } from './exerciseCompareBase';

export class ExerciseCompareAdv extends ExerciseCompareBase {
  constructor() {
    super('ExerciseCompareAdv', (gen, genData) => {
      // Generate 20 pairs, pick from the 3 closest in value for a harder comparison
      const sorted: { diff: number; a: any; b: any }[] = [];

      for (let i = 0; i < 20; i++) {
        const item1 = gen.generate(genData);
        const item2 = gen.generate(genData);
        const diff = Math.abs(parseNum(item1.answer) - parseNum(item2.answer));
        sorted.push({ diff, a: item1, b: item2 });
      }

      sorted.sort((a, b) => a.diff - b.diff);
      const top3 = sorted.slice(0, 3);
      const pick = top3[genData.random.next(0, top3.length)];

      return { a: pick.a, b: pick.b };
    });
  }
}

function parseNum(value: string): number {
  const n = parseFloat(value);
  return isNaN(n) ? 0 : n;
}
